import { useContext } from "react";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { ApiContext } from "../../contexts/ApiContext";

export function useGeneratedReportDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationKey: ["deleteGeneratedReport"],
    mutationFn: async (generatedReportId: number) =>
      apiContext.utp2ReportsAPIs.deleteGeneratedReport(generatedReportId),
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
